<template>
    <tickets :tickets="tickets" :epos="epos"></tickets>
</template>

<script>
    import Tickets from './Tickets';

    export default {
        name: "QrSection",
        components: {
            Tickets
        },
        data() {
            return {
                tickets: [],
                uuid: null,
                displayNoneLoop: false,
                ticketCount: null,

                //alx e-pos
                epos: {
                    enabled: false,
                    url: 'http://localhost:8347/uzpos',
                    token: 'DXJFX32CN1296678504F2',
                    printer_size: 80,
                    device_id: null,
                },
            }
        },
        created() {
            if (!this.$route.params['id']) {
                this.$router.push({name: 'cashier/dashboard-two'});
            } else if (this.$route.params['id']) {
                this.uuid = this.$route.params['id'];

                //alx e-pos
                let use_epos = this.$route.params['epos'];
                if (use_epos) {
                    this.get_epos_data();
                }
                this.$api.get('qr.images', {uuid: this.uuid})
                    .then(({data}) => {
                        this.tickets = data.tickets;
                        this.ticketCount = this.tickets.length;
                    })
            }
        },
        methods: {
            //alx e-pos
            get_epos_data() {
                let epos_data = {};
                this.$api.get('epos.data').then(res => {
                    epos_data = res.data;
                    if (epos_data.enabled) {
                        this.epos.enabled = true;
                        this.epos.url = epos_data.url;
                        this.epos.token = epos_data.token;
                        this.epos.printer_size = epos_data.printer_size;
                    }
                });
            },
            errorMsg(message) {
                if (_.isArray(message)) {
                    message.forEach(error => {
                        Vue.notify({
                            type: 'error',
                            group: 'foo',
                            title: '',
                            text: error.message
                        });
                    })
                } else {
                    Vue.notify({
                        type: 'error',
                        group: 'foo',
                        title: '',
                        text: message
                    });
                }
            },

            printImage() {
                this.displayNoneLoop = false;
                let mywindow = window.open('', 'PRINT', 'height=800,width=800');
                mywindow.document.write('<html><head><title>' + document.title  + '</title>');
                mywindow.document.write('</head><body >');
                mywindow.document.write(document.getElementById('one-ticket').innerHTML);
                mywindow.document.write('</body></html>');

                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10*/

                setTimeout(() => {
                    mywindow.print();
                    mywindow.close();
                }, 500)

            },
            printAll() {
                this.displayNoneLoop = false;
                let tickets = document.getElementsByClassName('tickets');
                let mywindow = window.open('', 'PRINT', 'height=800,width=800');
                mywindow.document.write('<html><head><title>' + document.title  + '</title>');
                mywindow.document.write('</head><body >');
                for (let i = 0; i < this.tickets.length; i++) {
                    let image = '<img src="' + this.tickets[i] + '" alt="Image" />' + '<hr>';
                    mywindow.document.write(image);
                }
                mywindow.document.write('</body></html>');
                mywindow.document.close();
                mywindow.focus();
                setTimeout(() => {
                    mywindow.print();
                    mywindow.close();
                }, 500)
            }


        }
    }
</script>

<style>
    .hidden {
        display: none;
    }

    .active {
        display: block;
    }
</style>
